<template>
  <layout>
    <template v-slot:content>
      <v-container class="grey lighten-5">
        <v-row>
          <v-col cols="4">
            <div>
              <h2 class="title">{{$t('moduleTitle')}}</h2>
            </div>
          </v-col>
          <v-col cols="4" class="d-flex align-center">
            <v-menu
                v-model="menuDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="initDate"
                      label="Fecha inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="initDate"
                  no-title
                  color="primary"
                  :max="new Date().toISOString()"
                  @input="menuDate2 = false"
                ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4" class="d-flex align-center">
            <v-menu
                v-model="menuDate1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="endDate"
                      label="Fecha final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  color="primary"
                  :max="new Date().toISOString()"
                  @input="menuDate2 = false"
                ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        
        <!-- Contenido del Dashboard -->
        <div class="cardView">
            <v-layout row wrap>
              <v-flex
                v-for="question in questions"
                :key="question.idQuestion"
              >
                <v-card
                  :color="'#e0e0e0'"
                  class="ma-3"
                  max-width="400"
                  elevation="8"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-card-title
                        class="headline"
                        v-text="question.question"
                      ></v-card-title>
                      <!-- <v-card-subtitle class="text-left" v-text="'Numero de preguntas contestadas'"></v-card-subtitle> -->

                      <v-card-text>
                        <div id="chartdivPie"></div>
                        <chart-component :answers="question.answers"/>
                      </v-card-text>
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div>
            <h2 class="title">{{$t('modueSecondTittle')}}</h2>
          </div>
          <!-- Tabla de contenido -->
              <v-data-table
                :headers="headers"
                :items="answers"
                :loading="isLoading"
                loading-text="Cargando elementos en tabla"
                color="primary"
              >
                <!-- Panel de acciones -->
                <!-- <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateSurveyDashboard(item)">
                        <v-icon>mdi-chart-pie</v-icon>
                      </v-btn>
                    </template>
                    <span>{{$t('lblEdit')}}</span>
                  </v-tooltip>
                </template> -->
              </v-data-table>
      </v-container>
    </template>
  </layout>
</template>

<script>
  import Layout from "@/components/Layouts/company";
  import i18nMessages from "./i18n.messages";
  import { mapGetters } from "vuex";

  import ChartComponent from "@/components/chartComponent";
  // import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  export default {
    i18n: i18nMessages,
    components: {
      layout: Layout,
      ChartComponent
    },
    props: {
      source: String,
    },
    data: () => ({
      panel: [0],
      totalUsers: 0,
      totalReservations: 0,
      totalParking: {
        value: 0,
        maxValue: 0
      },
      statusLDAP: '--',
      questions: [],
      //encabezados de la tabla
      headers: [
        { id: "headerUser", text: "Usuario", value: "dsUsuario", sortable: true },
        { id: "headerName", text: "Nombre", value: "dsNombre", sortable: true },
        { id: "headerMail", text: "Correo", value: "dsCorreo", sortable: true },
        { id: "headerQuestion", text: "Pregunta", value: "dsPregunta", sortable: true },
        { id: "headerDesc", text: "Respuesta", value: "dsRespuesta", sortable: false},
        { id: "headerDate", text: "Date", value: "ddUcambio", sortable: true},
      ],
      answers: [],
      initDate: null,
      endDate: new Date().toISOString().substr(0, 10),
      menuDate1: false,
      menuDate: false
    }),
    created () {
      this.$i18n.locale = this.locale;
      let date = new Date();
      date.setDate(date.getDate() - 7);
      this.initDate = date.toISOString().substr(0, 10);
      this.loadStatistics();
      this.loadAnswersDataTable();
    },

    computed: {
      ...mapGetters(["isLoading"]),
      locale() {
        return this.$store.getters["locale"];
      },
      unixInitDate(){
        let date = new Date(this.initDate);
        return date.getTime()/1000;
      },
      unixEndDate(){
        let date = new Date(this.endDate);
        date.setDate(date.getDate() + 1);
        return date.getTime()/1000;
      }
    },

    watch: {
      locale (value) {
        this.$i18n.locale = value;
        this.updateHeadersLocale();
      },
      initDate (){
        this.loadAnswersDataTable();
      },
      endDate (){
        this.loadAnswersDataTable();
      }
    },

    methods: {
      // Actualiza el idioma de los encabezados de la tabla
      updateHeadersLocale() {
        this.headers = this.headers.map(header => {
          header.text = this.$t(header.id);
          return header;
        });
      },
      loadStatistics(){
          let settings = {
                surveyId: this.$route.params.surveyId
            };
        this.$GETQA('/api/survey/{{surveyId}}/getAllAnswers', settings)
        .then(data => {
          // Carga de datos
          this.questions = data;
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('AttachProfile: Error al cargar infiormacion de preguntas')
        });
      },
      loadAnswersDataTable(){
        let settings = {
          surveyId: this.$route.params.surveyId,
          initDate: this.unixInitDate,
          endDate: this.unixEndDate
        };
        this.$GETQA('/api/survey/{{surveyId}}/getReplySurvey/{{initDate}}/{{endDate}}', settings)
        .then(data => {
          // Carga de datos
          this.answers = data;
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('AttachProfile: Error al cargar infiormacion de preguntas')
        });
      },
    },
  }
</script>

<style scoped>
.title{
  color: var(--v-primary-base);
}
.logo{
  width: 50%;
  margin: 10px;
}
#chartdivPie {
  width: 100%;
  height: 300px;
}
</style>